module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp23_7042.315340b9.png";